import React from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import { Grid, Typography, Paper } from "@mui/material";

const PieChartStyled = ({ title, staticsData }) => {
  console.log("🚀 ~ PieChartStyled ~ staticsData:", staticsData);
  const valueFormatter = (v) => {
    return `${v?.value}`;
  };
  // Tooltip personnalisé : affiche par exemple "6 Non traitées (≤2j)"
  const itemContentRender = ({ item }) => {
    return `${item.value} ${item.label}`;
  };

  // Extraire les couleurs dans un tableau
  const colors = staticsData.map((d) => d.color);

  // Nettoyer les données (retirer "color" pour éviter que le composant ne le traite mal)
  const cleanedData = staticsData.map(({ color, ...rest }) => rest);

  return (
    <Grid item xs={12} md={6}>
      <Paper
        elevation={3}
        sx={{ padding: 3, borderRadius: 4, textAlign: "center" }}>
        <Typography variant="h6" gutterBottom>
          Répartition des {title}
        </Typography>
        <PieChart
          series={[
            {
              data: cleanedData,
              highlightScope: { fade: "global", highlight: "item" },
              faded: {
                innerRadius: 30,
                additionalRadius: -30,
                color: "gray",
              },
              valueFormatter,
              colors,
            },
          ]}
          width={300}
          height={300}
          tooltip={{ itemContentRender }}
        />
      </Paper>
    </Grid>
  );
};

export default PieChartStyled;
